module.exports={render:function (){with(this) {
  return _h('div', [_h('invoices-add')])
}},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Invoices/Add.vue
 ** module id = 168
 ** module chunks = 2
 **/